<template>
  <PageTitleComponent
    v-if="range && range.label"
    :title="range.label.toUpperCase() + ' / ' + getTranslation(504)"
  />
  <div v-if="Object.keys(vehicles).length" class="range">
    <div class="range__vehicles">
      <div class="container">
        <div class="row">
          <div v-for="vehicle in vehicles" :key="vehicle.id" class="col-md-4">
            <VehicleCardComponent
              :currentVehicle="currentVehicle"
              :vehicle="vehicle"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <SideBarComponent v-if="currentVehicle.motors">
        <template v-slot:content>
          <div class="content__title">
            <div class="content__label">
              <span
                class="e-aixam -model me-2"
                v-html="processVehicleLabel()"
              ></span>
            </div>
            <div class="content__sub">{{ currentVehicle.motors[0].label }}</div>
          </div>
          <div class="content__price">
            <div class="content__from">
              {{
                getTranslation(276, {
                  PRICE: formatPrice(currentVehicle.motors[0].price),
                  CURRENCY: currency,
                })
              }}
            </div>
            <div class="content__installment">
              {{ formatPrice(currentVehicle.motors[0].installment) }}€ /
              {{ getTranslation(285).toLowerCase() }}
            </div>
            <div class="content__firstPayment">
              {{
                getTranslation(287, {
                  AMOUNT: formatPrice(currentVehicle.motors[0].first_payment),
                  CURRENCY: currency,
                })
              }}
            </div>
          </div>
          <div
            class="content__strength"
            v-html="currentVehicle.strength_2"
          ></div>
          <router-link
            :to="{
              name: 'Vehicle',
              params: {
                range: this.$route.params.range,
                vehicle: currentVehicle.id,
              },
            }"
            class="range__vehicle button"
            >{{ getTranslation(317) }}
            {{ currentVehicle.vehicle_label }}
            <template v-if="displayLabel()">
              {{ currentVehicle.label }}
            </template>
          </router-link>
        </template>
      </SideBarComponent>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "pinia";
import PageTitleComponent from "@/components/PageTitleComponent.vue";
import SideBarComponent from "@/components/SideBarComponent.vue";
import VehicleCardComponent from "@/components/VehicleCardComponent.vue";
import { priceManager } from "@/services/price-manager";
import { vehicleManager } from "@/services/vehicle-manager";
import { useMainStore } from "@/store";
import { getTranslation } from "@/services/translation-manager";

export default {
  name: "TypesView",
  components: { VehicleCardComponent, SideBarComponent, PageTitleComponent },
  computed: {
    ...mapState(useMainStore, {
      range: (store) => store.range,
      ranges: (store) => store.ranges,
      vehicles: (store) => store.vehicles,
      currentVehicle: (store) => store.vehicle,
      currency: (store) => store.currency,
    }),
  },
  watch: {
    ranges() {
      this.init();
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const rangeId = this.$route.params.range;
      this.toggleRange(rangeId);
      this.toggleVehicle();
    },

    getTranslation(id, params = {}) {
      return getTranslation(id, params);
    },

    formatPrice(price) {
      return priceManager.format(price);
    },

    processVehicleLabel() {
      return (
        vehicleManager.processLabel(this.currentVehicle.vehicle_label) +
        " " +
        (this.displayLabel() ? this.currentVehicle.label : "")
      );
    },

    displayLabel() {
      return (
        this.currentVehicle &&
        this.currentVehicle.vehicle_label &&
        !this.currentVehicle.vehicle_label.includes(this.currentVehicle.label)
      );
    },

    ...mapActions(useMainStore, ["toggleRange", "toggleVehicle"]),
  },
};
</script>

<style lang="scss" scoped>
.range {
  color: $white;
  height: 100%;
  width: 100%;
  background: url("@/assets/images/bg.jpg") no-repeat;

  &__vehicles {
    width: 71%;
    height: 100%;
    color: $blue;
    display: flex;
    align-items: center;
    padding: 0 200px 0 75px;
    background: $grey;
    clip-path: polygon(0 0, 100% 0, 85% 100%, 0% 100%);
  }
}

.range__vehicle {
  white-space: nowrap;
}

.content {
  &__title {
    border-left: 1px solid $white;
    padding-left: 15px;
    margin-bottom: 30px;
  }

  &__label {
    font-size: 45px;
    font-weight: 700;
    text-transform: uppercase;
    line-height: 0.9;
    margin-bottom: 15px;
  }

  &__sub {
    font-size: 20px;
    line-height: 0.9;
  }

  &__price {
    border-top: 1px solid $white;
    border-bottom: 1px solid $white;
    padding: 17px 0;
    width: 100%;
    margin-bottom: 40px;
  }

  &__from {
    font-size: 20px;
    line-height: 1;
  }

  &__firstPayment {
    line-height: 1;
    font-weight: 700;
    font-size: 16px;
  }

  &__installment {
    font-weight: 700;
    font-size: 35px;
  }

  &__strength {
    line-height: 1.8;
    margin-bottom: 35px;
    font-family: $font-roboto;
    font-size: 20px;
  }
}
</style>
